import { render } from "./TypeWriter.vue?vue&type=template&id=19ca1eb8&scoped=true"
import script from "./TypeWriter.vue?vue&type=script&lang=js"
export * from "./TypeWriter.vue?vue&type=script&lang=js"

import "./TypeWriter.vue?vue&type=style&index=0&id=19ca1eb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ca1eb8"]])

export default __exports__